import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, toast } from '@livable/saas-react-components';
import { Divider, Button, Menu } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const InactiveBuildingMenu = observer(_ref => {
  let id = _ref.id,
    menuTriggerExternal = _ref.menuTriggerExternal,
    deletePropertyCallBackAction = _ref.deletePropertyCallBackAction;
  const classes = useStyles();
  const navigate = useNavigate();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const discardProperty = async () => {
    const resp = await store.properties.deletePropertyAsync.run({
      propertyId: id
    });
    if (resp && resp.isSuccessful) {
      toast('success', {
        body: ['Successfully deleted']
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      deletePropertyCallBackAction && deletePropertyCallBackAction();
    }
  };
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '94-inactive-building-menu'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null)), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => navigate("/new_property?not_completed_id=".concat(id)),
    'custom-attribute': '95-inactive-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('dashboard_page.continue_adding_details')), !store.company.companyFeatureStore.disableDeleteIncompletedProperty && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: discardProperty,
    'custom-attribute': '96-inactive-building-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }), t('dashboard_page.discard_property')))));
});